/**
 * @fileOverView
 * @description dummy model for a page header view if none other is specified<br>
 * @copyright 2015-present Flatirontek LLC
 **/

const app = require('ampersand-app');

const AmpersandModel = require('ampersand-model');
const demoSearchTemplate = require('../templates/components/demosearch.html');

const Login = AmpersandModel.extend({

    session: {
        "maintitle": ['string',true,'Welcome to Vybit!'],
        "showGettingStarted" : ['boolean',true,true],
        "showStoreLinks" : ['boolean', true, true],
        "loginMessage" : ['string',true,''],
        //email and password panel: '' (closed), 'signin', 'create', 'reset' (request a link), or 'newpassword' (from a reset link)
        "passwordMode" : ['string', true, ''],
        "passwordMessage" : ['string', true, ''],
        "passwordMessageClass" : ['string', true, '']
    },

    derived: {
        passwordCardClass: {
            deps: ['passwordMode'],
            fn: function() { return this.passwordMode ? 'vpwopen' : ''; }
        },
        passwordFieldVisibility: {
            deps: ['passwordMode'],
            fn: function() { return this.passwordMode === 'reset' ? 'vhide' : ''; }
        },
        passwordAltLinksVisibility: {
            deps: ['passwordMode'],
            fn: function() { return this.passwordMode === 'signin' ? '' : 'vhide'; }
        },
        passwordBackVisibility: {
            deps: ['passwordMode'],
            fn: function() { return this.passwordMode && this.passwordMode !== 'signin' ? '' : 'vhide'; }
        },
        passwordSubmitLabel: {
            deps: ['passwordMode'],
            fn: function() { return {create: 'Create Account', reset: 'Send Reset Link', newpassword: 'Set Password'}[this.passwordMode] || 'Sign in with Password'; }
        },

        displayGettingStarted: {
            deps: ['showGettingStarted'],
            fn: function(){
                if(this.showGettingStarted){
                    return app.utils.externalLinkHtml(app.utils.wwwUrl(), 'Getting Started');
                }else{
                    return "";
                }
            }
        },

        displayLoginMessage: {
            deps: ['loginMessage'],
            fn: function() {

                //preset
                if(window.localStorage.getItem('loginMessage')!=null){
                    this.loginMessage = window.localStorage.getItem('loginMessage');
                    window.localStorage.removeItem('loginMessage');

                }else if(app.platform === "browser" && this.loginMessage === "" && !app.queryParams.client_id && !app.queryParams.sk && !window.localStorage.getItem('serviceAuth')){

                    this.loginMessage = demoSearchTemplate();

                }else if((app.queryParams.client_id && app.queryParams.client_id.length > 0) || 
                         window.localStorage.getItem('serviceAuth')){
                    
                    const clientId = app.queryParams.client_id || window.localStorage.getItem('serviceAuth');
                    const authType = window.localStorage.getItem('serviceAuthType');
                    
                    let serviceName;
                    if (authType === 'legacy') {
                        serviceName = app.config.serviceAuth[clientId]?.displayName || clientId;
                    } else if (authType === 'oauth2') {
                        serviceName = window.localStorage.getItem('oauth2ServiceName') || clientId;
                    } else {
                        serviceName = clientId;
                    }
                    
                    this.loginMessage = this.serviceSignInMessage(serviceName);

                }

                return this.loginMessage;
            }
        },

        displayStoreLinks: {
            deps: ['showStoreLinks'],
            fn: function(){
                if(this.showStoreLinks){
                    return '    <div class="vstorelinks vweb">\n' +
                        '        <span>\n' +
                        '                            <a target="_ios" href="https://apps.apple.com/us/app/vybit/id1519874653">\n' +
                        '                                <img src="images/40px-Download_on_the_App_Store_Badge.png"/>\n' +
                        '                            </a>\n' +
                        '                        </span> &nbsp;\n' +
                        '        <span>\n' +
                        '                            <a target="_android" href="https://play.google.com/store/apps/details?id=com.vybit">\n' +
                        '                                <img src="images/googleplay.png"/>\n' +
                        '                            </a>\n' +
                        '                        </span>\n' +
                        '    </div>';
                }else{
                    return "";
                }
            }
        },

        displayAppleLogin: {
            deps: [],
            fn: function() {
                return app.platformId === "android" ? "vhide" : "";
            }
        },

        displayLoginMessageClass: {
            deps: [],
            fn: function() {
                return app.platformId === "android" ? "vloginmessage-android" : "";
            }
        }
    },

    serviceSignInMessage: function(serviceName) {
        //rendered as HTML, and the name comes from the client's own registration or, before it loads, the URL
        const name = app.utils.escapeHtml(serviceName);
        const selfRegistered = window.localStorage.getItem('serviceAuthType') === 'oauth2' &&
            window.localStorage.getItem('oauth2SelfRegistered') === 'true';
        const note = selfRegistered ? `<div class="vconsent-namenote">${app.utils.escapeHtml(app.utils.unverifiedNameNote(serviceName))}</div>` : '';
        return `Sign in to allow ${name} access to your Vybit account.${note}`;
    }

});

module.exports = Login;
